import React from 'react';
export function CtaBanner() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 w-full" style={{
    backgroundColor: '#1a2e4a'
  }} aria-labelledby="cta-title" data-id="element-23">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-24">
        {/* Title */}
        <h2 id="cta-title" className="font-heading text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-25">
          Transformá tus clases con el
          <br data-id="element-26" />
          <span className="text-gold" data-id="element-27">Mega Pack Catequesis Lista</span>
        </h2>

        {/* Subtitle */}
        <p className="text-gold text-lg sm:text-xl mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-28">
          Accedé hoy mismo a los 12 tomos, actividades y los 3 bonos exclusivos.
          Empezá a disfrutar más de tu tiempo libre.
        </p>

        {/* CTA Button */}
        <button onClick={() => scrollTo('precios')} className="bg-gold text-navy-deep font-bold text-xl px-12 py-5 rounded-full hover:bg-gold-light transition-all duration-200 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 mb-6" aria-label="Ir a la sección de precios para adquirir el Mega Pack" data-id="element-29">
          ¡Quiero el Mega Pack Ahora!
        </button>

        {/* Trust indicators */}
        <p className="text-white opacity-60 text-sm" data-id="element-30">
          Acceso inmediato &nbsp;•&nbsp; Pago seguro &nbsp;•&nbsp; Garantía de
          satisfacción
        </p>
      </div>
    </section>;
}